import { render, staticRenderFns } from "./staticNotify.vue?vue&type=template&id=2bf713e7&scoped=true"
import script from "./staticNotify.vue?vue&type=script&lang=js"
export * from "./staticNotify.vue?vue&type=script&lang=js"
import style0 from "./staticNotify.vue?vue&type=style&index=0&id=2bf713e7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf713e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf713e7')) {
      api.createRecord('2bf713e7', component.options)
    } else {
      api.reload('2bf713e7', component.options)
    }
    module.hot.accept("./staticNotify.vue?vue&type=template&id=2bf713e7&scoped=true", function () {
      api.rerender('2bf713e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/staticNotify.vue"
export default component.exports